import { getAuthTokenAsync } from "src/store/common";
import * as api from "./api";
import type { Restaurant } from "src/store/types";
import axios from "axios";

interface ApiResponse {
  status: number;
  message: string;
  data: Restaurant[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

// Fetch restaurant list
export const fetchRestaurantList = async (data: {
  search: string;
  page: number;
  limit: number;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/restaurant`,
    params,
  );
  return response;
};

// Create restaurant
export const createRestaurant = async (data: {
  name: string;
  latitude: string;
  longitude: string;
  address: string;
}): Promise<ApiResponse> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.post(
    `${process.env.REACT_APP_ADMIN_API_URL}/restaurant`,
    data,
  );
  return response;
};

// Delete restaurant
export const deleteRestaurant = async (id: number): Promise<ApiResponse> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.remove(
    `${process.env.REACT_APP_ADMIN_API_URL}/restaurant/${id}`,
  );
  return response;
};

// Update restaurant
export const updateRestaurant = async (
  id: number,
  data: {
    name: string;
    latitude: string;
    longitude: string;
    address: string;
  },
): Promise<ApiResponse> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.put(
    `${process.env.REACT_APP_ADMIN_API_URL}/restaurant/${id}`,
    data,
  );
  return response;
};

export const downloadQRCode = async (rid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const url = `${process.env.REACT_APP_ADMIN_API_URL}/restaurant/${rid}/download`;

  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "*/*",
    },
    responseType: "blob",
  });

  // Get content type from response
  const contentType = response.headers["content-type"] || "image/png";

  // Create downloadable file
  const blob = new Blob([response.data], { type: contentType });
  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = downloadUrl;
  link.setAttribute("download", `restaurant-${rid}-qr-code.png`);
  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(downloadUrl);
  document.body.removeChild(link);

  return true;
};
